"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FileReference {
    toJSON() {
        return Object.assign({}, new Object(this), { url: this.url, createdAt: this.createdAt.toISO() });
    }
    constructor({ id, mimetype, size, originalName, createdAt, url, }) {
        this.id = id;
        this.mimetype = mimetype;
        this.size = size;
        this.originalName = originalName;
        this.createdAt = createdAt;
        this.url = url;
    }
}
exports.default = FileReference;
